import categories from "../../data/Categories";
import PlusIcon from "../../assets/images/accounts-dashboard/plus-icon.png"
import { categoryTransactions } from '../../helpers/ExpensesByCategory';

const AccountsCategories = (props) => {
    return (
        <article className="accounts-categories">
        </article>
    )
}

export default AccountsCategories;